/**
 * Payroll Tour Configuration
 * 
 * Step-by-step tour guide for the Payroll page,
 * explaining main sections for processing payroll.
 */

export const getPayrollTourSteps = (t) => {
  // Helper function to check if an element exists in the DOM
  const elementExists = (selector) => {
    if (typeof document === 'undefined') {return false;}
    const element = document.querySelector(selector);
    return element !== null && element.offsetParent !== null;
  };

  // Base steps that always appear
  const baseSteps = [
    {
      selector: '[data-tour="payroll-header"]',
      content: t('tour.payroll.header', {
        ns: 'common',
        defaultValue: 'Upload CSV files with employee payroll data.'
      }),
      position: 'bottom'
    }
  ];

  // Upload panel steps
  const uploadSteps = [
    {
      selector: '[data-tour="payroll-download"]',
      content: t('tour.payroll.download', {
        ns: 'common',
        defaultValue: 'Download CSV template to fill with employee payroll data.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="payroll-upload"]',
      content: t('tour.payroll.upload', {
        ns: 'common',
        defaultValue: 'Upload your completed CSV file here. Drag and drop or click to select.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="payroll-requirements"]',
      content: t('tour.payroll.requirements', {
        ns: 'common',
        defaultValue: 'Review file requirements and format instructions here.'
      }),
      position: 'bottom'
    }
  ];

  // Preview panel steps (only shown when file is uploaded)
  const previewSteps = [
    {
      selector: '[data-tour="payroll-summary"]',
      content: t('tour.payroll.summary', {
        ns: 'common',
        defaultValue: 'Review file summary: total employees, amount, and file details.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="payroll-preview"]',
      content: t('tour.payroll.preview', {
        ns: 'common',
        defaultValue: 'Review all employee data before approving payroll.'
      }),
      position: 'bottom'
    }
  ];

  // Build steps based on what exists in the DOM
  const allSteps = [...baseSteps];

  // Check if upload panel is active
  const isUploadActive = elementExists('[data-tour="payroll-download"]') || elementExists('[data-tour="payroll-upload"]');
  // Check if preview panel is active
  const isPreviewActive = elementExists('[data-tour="payroll-summary"]');

  if (isUploadActive) {
    // Add upload steps only if upload panel is active
    allSteps.push(...uploadSteps.filter(step => elementExists(step.selector)));
  } else if (isPreviewActive) {
    // Add preview steps only if preview panel is active
    allSteps.push(...previewSteps.filter(step => elementExists(step.selector)));
  }

  if (elementExists('[data-tour="payroll-history-info"]')) {
    allSteps.push({
      selector: '[data-tour="payroll-history-info"]',
      content: t('tour.payroll.history', {
        ns: 'common',
        defaultValue: 'For full payroll history, filtering, and exports, visit the Reports page.',
      }),
      position: 'top',
    });
  }

  return allSteps;
};

